import { sendEvent } from 'src/shared/api/events/send-event'
import { ConversionAction, useConversionTracking } from 'src/shared/hooks/use-conversion-tracking'
import { useEventStore } from 'src/shared/store/event-store'

interface ConsumerStartJourneyEventProps {
  pageName: string
  action: 'open_sms' | 'phone_number' | 'phone_number_submit' | 'phone_number_submit_error'
  flowId?: string
  error?: string
  tag?: string
}

// Actions and pages that should be tracked as ad conversions.
const conversionActions = ['open_sms', 'phone_number_submit']
const conversionPages = ['affordable', 'approved', 'findAnAgent']

export const useConsumerStartJourneyEvent = () => {
  const { gclid, fbclid, utmParams, sessionId, anonymousId, setAnonymousId, setSessionId } = useEventStore()
  const { trackConversion } = useConversionTracking()
  const googleAnalytics = {
    ...(gclid ? { gclid } : {}),
    ...(fbclid ? { fbclid } : {}),
    ...(utmParams?.source ? { utm_source: utmParams.source } : {}),
    ...(utmParams?.medium ? { utm_medium: utmParams.medium } : {}),
    ...(utmParams?.campaign ? { utm_campaign: utmParams.campaign } : {}),
    ...(utmParams?.term ? { utm_term: utmParams.term } : {}),
  }

  return async ({ pageName, action, flowId, error, tag }: ConsumerStartJourneyEventProps) => {
    let currentAnonymousId = anonymousId
    if (!currentAnonymousId) {
      currentAnonymousId = setAnonymousId()
    }

    let currentSessionId = sessionId
    if (!currentSessionId) {
      currentSessionId = setSessionId()
    }

    // Only track conversion if the action is a phone number submission or SMS open.
    // And only if the page is in the list of conversion pages.
    if (conversionActions.includes(action) && conversionPages.includes(pageName)) {
      await trackConversion(ConversionAction.START_JOURNEY_BTN, 1.0)
    }

    await sendEvent({
      eventType: 'consumer_start_journey',
      ...(currentAnonymousId ? { anonymousId: currentAnonymousId } : {}),
      info: {
        ...googleAnalytics,
        ...(currentSessionId ? { sessionId: currentSessionId } : {}),
        ...(flowId ? { flowId } : {}),
        page: pageName,
        action,
        ...(tag ? { tag } : {}),
        ...(error ? { error } : {}),
      },
    })
  }
}
